window.anvil.block('hero-retail', (el, data) => {
    const sliderImages = el.querySelector('.slider-images');

    if (sliderImages) {
        new Swiper(sliderImages, {
            grabCursor: true,
			autoplay: {
                reverseDirection: true
            },
            effect: data.effect ? data.effect : 'slide',
            fadeEffect: data.effect != 'slide' ? { crossFade: true } : false,
            speed: 1500,
            loop: true,
            initialSlide: data.background_slides.length - 1,
        });
    }
});
